module.exports = __webpack_public_path__ + "static/media/CircularPro-Book.0c844586.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Book.woff
// module id = 105
// module chunks = 0